module.exports = __webpack_public_path__ + "img/graph.8fc40bbc.svg";